import { ContractServicePromiseClient } from "@/pb/scout/contract/v1/contract_grpc_web_pb";
import { RpcError } from "grpc-web";
import { handleGrpcError } from "@/grpc-web/utils";
import {
  GetScoutRequest,
  GetAgentContractRequest
} from "@/pb/scout/contract/v1/contract_pb";

const client: ContractServicePromiseClient = Object.assign(
  new ContractServicePromiseClient(
    process.env.VUE_APP_SCOUT_GRPC_ORIGIN,
    null,
    {
      withCredentials: true
    }
  )
);

export const getScout = async () => {
  const request = new GetScoutRequest();
  return await client.getScout(request).catch((e: RpcError) => {
    handleGrpcError(e);
    throw e;
  });
};

export const getAgentContract = async () => {
  const request = new GetAgentContractRequest();
  return await client.getAgentContract(request).catch((e: RpcError) => {
    handleGrpcError(e);
    throw e;
  });
};
